function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext } from "react";
import { NavLink as _NavLink, matchPath, useResolvedPath } from "react-router-dom";
import PropTypes from "prop-types";
import { stringify } from "qs";
import { RoutesContext } from "./RoutesContextProvider";
import useGeneratePath from "./generatePath";
NavLink.propTypes = {
    to: PropTypes.string,
    params: PropTypes.object,
    query: PropTypes.object,
    end: PropTypes.bool,
    target: PropTypes.string,
    className: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.string
    ]),
    children: PropTypes.node
};
export default function NavLink(_param) {
    var to = _param.to, _param_params = _param.params, params = _param_params === void 0 ? {} : _param_params, _param_query = _param.query, query = _param_query === void 0 ? {} : _param_query, _param_target = _param.target, target = _param_target === void 0 ? null : _param_target, props = _object_without_properties(_param, [
        "to",
        "params",
        "query",
        "target"
    ]);
    var routes = useContext(RoutesContext).routes;
    var generatePath = useGeneratePath();
    var resolvedPath = useResolvedPath();
    var search = stringify(query);
    if (!to) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.values(routes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var pattern = _step.value;
                if (matchPath(pattern, resolvedPath.pathname)) {
                    to = pattern;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    if (target) {
        return /*#__PURE__*/ React.createElement("a", {
            href: to,
            target: target,
            className: props.className({
                isActive: false
            })
        }, props.children);
    }
    var pathname = generatePath(to, params);
    // we allow the navlink to retrigger the navigation change even if
    // if it's the same route so that it closes the sidebar
    return /*#__PURE__*/ React.createElement(_NavLink, _object_spread_props(_object_spread({}, props), {
        to: {
            pathname: pathname,
            search: search
        }
    }));
}
